import React, { useState } from 'react';
import cls from 'classnames';
import { exportGraph } from '../../lib/export';
import { useGraph, useGraphVariables, useRenderer } from '../../hooks';
import ExportGexfPanel from './ExportGexfPanel';
import ExportJsonPanel from './ExportJsonPanel';
import ExportImagePanel from './ExportImagePanel';
import ExportSvgPanel from './ExportSvgPanel';
import ExportMinivanPanel from './ExportMinivanPanel';
import './ExportModal.scss';
var PANELS = {
    gexf: ExportGexfPanel,
    json: ExportJsonPanel,
    image: ExportImagePanel,
    svg: ExportSvgPanel,
    minivan: ExportMinivanPanel
};
var TABS = [
    { label: 'as a GEXF file', tab: 'gexf' },
    { label: 'as a JSON file', tab: 'json' },
    { label: 'as a SVG file', tab: 'svg' },
    { label: 'as a raster image', tab: 'image' },
    { label: 'as a minivan bundle', tab: 'minivan' }
];
export default function ExportModal(_a) {
    var isOpen = _a.isOpen, close = _a.close;
    var graph = useGraph();
    var renderer = useRenderer()[0];
    var variables = useGraphVariables();
    var _b = useState('gexf'), activeTab = _b[0], setActiveTab = _b[1];
    if (!graph || !renderer || !variables)
        return null;
    var setActiveTabIfDifferent = function (newActiveTab) {
        if (newActiveTab === activeTab)
            return;
        setActiveTab(newActiveTab);
    };
    var PanelComponent = PANELS[activeTab];
    var rendererDimensions = renderer.getDimensions();
    var rendererSize = Math.min(rendererDimensions.width, rendererDimensions.height);
    return (React.createElement("div", { id: "ExportModal", className: cls('modal', isOpen && 'is-active') },
        React.createElement("div", { className: "modal-background", onClick: close }),
        React.createElement("div", { className: "modal-content", style: { width: '75%' } },
            React.createElement("div", { className: "export-modal-box" },
                React.createElement("h2", null, "Export"),
                React.createElement("div", { className: "tabs" },
                    React.createElement("ul", null, TABS.map(function (item) {
                        return (React.createElement("li", { key: item.tab, className: cls(activeTab === item.tab && 'is-active'), onClick: setActiveTabIfDifferent.bind(null, item.tab) },
                            React.createElement("a", null, item.label)));
                    }))),
                React.createElement(PanelComponent, { graph: graph, variables: variables, rendererSize: rendererSize, save: exportGraph })))));
}
